// extracted by mini-css-extract-plugin
export default {"DetailOverview":"Update_DetailOverview__F4uqC","Detail":"Update_Detail__QLyOf"};